import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { siteUrl } from "../../../utils/siteUrl"
import "./favorite-products.scss"
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"

const FavoriteProducts = props => {
  const resultQuery = useStaticQuery(
    graphql`
      query PATERN_INFO {
        allContentfulNolHome {
          nodes {
            node_locale
            bannerDeTiendasTransversal {
              imagenDestacada {
                fluid(maxWidth: 1920) {
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                }
              }
              imagenDestacadaMobile {
                fluid(maxWidth: 1920) {
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                }
              }
              botonRedireccion
            }
          }
        }
      }
    `
  )

  const imgFavoriteProducts = resultQuery.allContentfulNolHome.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )

  const favoriteProductDatalayer = () => {
        pushDataLayerEvent({
          event: "Interacciones - Banners",
          category: "banner_final",
          action: "click",
          label: "nosotrasonline.com.co/productos/tiendas/",
          Location: window.location.href,
        })
  }

  return (
    <div className="f-section-favorite-products">
      <a href={siteUrl + "/productos/tiendas"} onClick={() => favoriteProductDatalayer()}>
        <Img
          fluid={[
            imgFavoriteProducts[0].bannerDeTiendasTransversal
              .imagenDestacadaMobile.fluid,
            {
              media: `(min-width: 1023px)`,
              ...imgFavoriteProducts[0].bannerDeTiendasTransversal
                .imagenDestacada.fluid,
            },
          ]}
          className="f-section-favorite-products__img"
        />
      </a>
    </div>
  )
}

export default FavoriteProducts
